<template>
  <div class="adviser scrool" id="school">
    <div class="school-box">
      <div class="tit">
        <img src="@/assets/images/tit-school.jpg" alt />
      </div>

      <div class="school-content">
        <ul class="con-tab2">
          <li :class="{ active: item.id == countryId }" v-for="(item, index) in countryList" :key="index" @click="countryId = item.id;tabIndex=0">{{ item.name }}</li>
        </ul>

        <!-- 院校列表 -->
        <div class="tab" v-if="dataList.length > 0">
          <ul>
            <li v-for="(item, index) in itemlist" :key="index" :class="{active:item.id == tabIndex}" @click="tabIndex=item.id">
              <div class="img-box">
                <img :src="item.badge" alt />
              </div>
              <p>{{ item.schoolName }}</p>
            </li>
          </ul>
        </div>

        <!-- 顾问详情 -->
        <div class="con" v-if="dataList.length>0">
          <div class="box">
            <div class="left">
              <img :src="item.head" :alt="item.name" />
            </div>
            <div class="right">
              <h5>{{ item.name }}</h5>
              <b>{{ item.position }}</b>
              <p class="ofw-hide-4" :title="item.introduction">{{ item.introduction }}</p>
            </div>
          </div>
          <div class="box2">
            <p class="ofw-hide">
              <img src="@/assets/images/school_current.png" alt />
              {{ item.schoolName }}
            </p>
            <p>
              <span class="btn btn1" @click="tips(item.id)" v-if="status <= 2 && isMake != item.id">提前预约</span>
              <span class="btn btn2" @click="tips" v-else-if="status <= 2 && isMake == item.id">预约成功</span>
              <span class="btn btn3" v-else>预约结束</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约提示框 -->
    <Modal @appointment="appointment" @closeModal="modalType = -1" :type="modalType" :msg="modalmsg" :title="modaltitle" />
  </div>
</template>

<script>
// import { getTimeStatus } from '@/utils/utils'
import { getSchoolList, guestSubscribe, checkGuestSubscribe } from "@/api/home";
import Modal from "@/components/modal.vue";
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    expoId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      dataList: [],
      schoolIndex: 0,
      status: 0, //2可预约/3预约结束
      modalType: -1,
      modalmsg: "",
      modaltitle: "",
      title: "院校咨询区",
      desc: "",
      isMake: 0, //预约嘉宾
      countryId: 0,
      itemData: null,
      tabIndex: 0,
      id: "", //顾问id
    };
  },
  computed: {
    countryList: {
      get: function () {
        if (this.dataList.length > 0) {
          return this.dataList.map((it) => {
            return { id: it.id, name: it.name.split("-")[0] };
          });
        }
      },
    },
    itemlist: {
      get: function () {
        if (this.dataList.length > 0) {
          if (this.countryId > 0) {
            return this.dataList.filter((it) => it.id == this.countryId)[0]
              .guests;
          } else {
            this.countryId = this.dataList[0].id;
            return this.dataList[0].guests;
          }
        }
        return [];
      },
    },
    item: {
      get: function () {
        if (this.itemlist.length > 0) {
          if (this.tabIndex > 0) {
            return this.itemlist.filter((it) => it.id == this.tabIndex)[0];
          } else {
            this.tabIndex = this.itemlist[0].id;
            return this.itemlist[0];
          }
        }
      },
    },
  },
  methods: {
    // 获取院校咨询区
    async getSchoolList() {
      const res = await getSchoolList({
        params: {
          expoId: this.expoId,
        },
      });
      if (res.succ) {
        this.dataList = res.results;
        this.status = res.results[0].subscribeStatus;
        this.checkGuestSubscribe();
      }
    },

    // 判断用户是否预约嘉宾
    async checkGuestSubscribe() {
      let res = await checkGuestSubscribe({
        expoId: this.expoId,
        guestId: this.dataList[0].guests[0].id,
      });
      if (res.succ) {
        this.isMake = res.results.guestId;
      }
    },

    // 点击弹出预约提示框
    tips(id) {
      if (id) {
        this.id = id;
      }
      if (!this.isLogin) {
        this.$emit("showLogin", "adviser");
        return;
      }
      if (this.isMake > 0) {
        this.modalType = 2;
        this.modaltitle = "请勿重复预约";
        this.modalmsg =
          "您已经成功预约了一个院校咨询服务，<br>不能重复预约，祝您咨询愉快。";
      } else {
        this.modalType = 0;
        this.modalmsg =
          "院校预约只能预约一位，<br>预约后不可修改，请您进行确认?";
      }
    },

    async appointment() {
      const { code, succ } = await guestSubscribe({
        expoId: this.expoId,
        guestId: this.id,
      });
      this.isShowModal = true;
      if (succ) {
        //当前时间
        let date = new Date();
        let now = date.getTime();
        //开始时间
        let startDate = new Date("2020/11/28 10:00:00");
        let start = startDate.getTime();
        //结束时间
        let endDate = new Date("2020/11/28 18:00:00");
        let end = endDate.getTime();

        if (now > start && now < end) {
          this.appointmentEnd();
        } else {
          this.modalType = 1;
          this.modaltitle = "您已成功预约";
          this.modalmsg =
            "您已提交申请，<br>我们的工作人员会尽快与您联系，请保持电话畅通。";
        }

        this.isMake = this.id;
      } else {
        this.modalType = 2;
        this.modaltitle = "请勿重复预约";
        this.modalmsg =
          "您已经成功预约了一个院校咨询服务，<br>不能重复预约，祝您咨询愉快。";
      }
    },
    appointmentEnd() {
      this.modalType = 2;
      this.modaltitle = "目前预约席位紧张";
      this.modalmsg = "我们的工作人员将为您联系安排，请保持电话通畅";
    },
  },
  created() {
    if (this.expoId) {
      this.getSchoolList();
    }
  },
  watch: {
    expoId(newVal) {
      if (newVal) {
        this.getSchoolList();
      }
    },
  },
};
</script>

<style lang="less">
.scrool {
  background: #f4f8fd; //url(~@/assets/images/school_icon1.png) no-repeat left top;
  background-size: 100% auto;
  position: relative;
  .school-box {
    background-color: #f4f8fd;
    padding-bottom: 0.5rem;
    .school-content {
      margin: 0 0.3rem;
      border-radius: 0.1rem;
      border: 0.03rem solid #77b6ff;
      overflow: hidden;
      background-color: #f4faff;

      .con-tab2 {
        display: flex;
        justify-content: space-around;
        background: linear-gradient(24deg, #97cbfa, #379af4);
        align-items: center;
        height: 0.76rem;
        padding: 0 0.3rem;
        li {
          padding: 0.02rem 0.15rem;
          border-radius: 1rem;
          font-size: 0.26rem;
          font-weight: 900;
          color: #fff;
          &.active {
            background-color: #0358dd;
            border: 0.02rem solid #fff;
            border-radius: 0 0.16rem 0.16rem 0.16rem;
          }
        }
      }
      .tab {
        ul {
          display: flex;
          flex-wrap: wrap;
          padding: 0.3rem 0;
          height: 4.5rem;
          li {
            width: 25%;
            .img-box {
              width: 0.9rem;
              height: 0.9rem;
              border-radius: 50%;
              border: 0.02rem solid #c4c4c4;
              background-color: #fff;
              margin: 0.2rem auto;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
              }
            }
            p {
              font-size: 0.24rem;
              text-align: center;
              padding: 0 0.1rem;
              color: #777777;
            }
            &.active {
              .img-box {
                border: 0.06rem solid #ff7f00;
              }
              p {
                font-weight: bold;
                color: #ff7f00;
              }
            }
          }
        }
      }
      .con {
        background: #ffffff;
        border-radius: 0.1rem;
        position: relative;
        margin: 0 0.1rem 0.2rem;
        border: 0.02rem solid #67b2f7;
        padding: 0.2rem;
        .box {
          display: flex;
          justify-content: space-between;
          .left {
            width: 1.6rem;
            height: 1.6rem;
            display: flex;
            align-items: center;
            background-color: #e2e7f2;
            border-radius: 50%;
            overflow: hidden;
            //margin-top: 0.2rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right {
            width: 4.4rem;
            h5 {
              font-size: 0.26rem;
              font-weight: 900;
              padding-left: 0.1rem;
              margin-left: -0.1rem;
            }
            b {
              font-size: 0.22rem;
              color: #ff7f00;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: 4.26rem;
              display: block;
              margin-bottom: 0.06rem;
            }
            p {
              padding-top: 0.05rem;
              color: #666;
              font-size: 0.22rem;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3; //行数需设置
              line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }
        .box2 {
          padding-top: 0.4rem;
          font-size: 0.24rem;
          font-weight: 900;
          display: flex;
          justify-content: space-between;
          p {
            img {
              width: 1.36rem;
              margin-right: 0.1rem;
              vertical-align: middle;
            }
            .btn {
              display: block;
              width: 1.45rem;
              height: 0.4rem;
              line-height: 0.4rem;
              text-align: center;
              color: #fff;

              &.btn1 {
                background: #fc6822; // url(~@/assets/images/mx_play.png) no-repeat 1.1rem  center;
              }
              &.btn2 {
                background: #1b76e8; // url(~@/assets/images/mx_play.png) no-repeat 1.1rem  center;
              }
              &.btn3 {
                background: #b2b0b0; // url(~@/assets/images/mx_play.png) no-repeat 1.1rem center;
              }
            }
          }
        }
        .name {
          width: 2.8rem;
          font-size: 0.26rem;
          font-weight: bold;
          position: absolute;
          left: 1.85rem;
          bottom: 0.39rem;
        }
      }
      .swiper-container {
        padding-left: 0.3rem;
        padding-right: 0.3rem;
        height: 5.5rem;
        .all-school {
          display: block;
          position: absolute;
          right: 0.1rem;
          bottom: 0.22rem;
          font-size: 0.18rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #636c77;
          z-index: 13;
        }
        .swiper-wrapper {
          z-index: 11;
        }
      }
      .swiper-pagination {
        z-index: 12;
        width: 2rem;
        left: 30%;
      }
    }
  }
}
</style>